export default "__VITE_ASSET__c10494c3__"